import { AnalysisRequirementItem } from 'modules/analyse/types/AnaylsisRequirementItem';
import { AnalysisRequirementInputWithExtras } from 'modules/analyse/types/AnalysisRequirementInputWithExtras';
import { getRandomId } from 'core/utils/getRandomId';

export const formatAnalysisRequirementItemToInputWithKey = (
  analysisRequirements: AnalysisRequirementItem[]
): AnalysisRequirementInputWithExtras[] =>
  analysisRequirements.map<AnalysisRequirementInputWithExtras>(
    (analysisRequirement) => ({
      content: analysisRequirement.originalRequirementText,
      isMandatory: analysisRequirement.isMandatory,
      weight: analysisRequirement.weight,
      id: analysisRequirement.id,
      isRecommendationDismissed: analysisRequirement.isRecommendationDismissed,
      recommendationCategory: analysisRequirement.recommendationCategory,
      recommendationText: analysisRequirement.recommendationText,
      requirementMetCandidatesCount:
        analysisRequirement.requirementMetCandidatesCount,
      key: getRandomId()
    })
  );
